import { extendComponentAdapter } from '../helpers/extendAdapter'
import { ComponentAdapter } from './componentFactory'
import { AdaptedRepeaterComponent, repeaterAdapter } from './repeaterAdapter'
import { WixDynamicRepeaterComponent } from './types'

export type AdaptedDynamicRepeaterComponent = AdaptedRepeaterComponent & DynamicRepeaterExtendedApi

interface DynamicRepeaterExtendedApi {
  loadMoreButton: NonNullable<WixDynamicRepeaterComponent['loadMoreButton']>
}

export const dynamicRepeaterAdapter: ComponentAdapter<
  WixDynamicRepeaterComponent,
  AdaptedDynamicRepeaterComponent
> = component => {
  const { loadMoreButton } = component

  const extendedApi: DynamicRepeaterExtendedApi = {
    loadMoreButton: {
      get hidden() {
        return 'hidden' in loadMoreButton ?
          Boolean(loadMoreButton.hidden) :
          false
      },
      get visible() {
        return !extendedApi.loadMoreButton.hidden
      },
      hide() {
        if (!extendedApi.loadMoreButton.hidden) {
          loadMoreButton.hide?.()
        }
      },
      show() {
        if (!extendedApi.loadMoreButton.visible) {
          loadMoreButton.show?.()
        }
      },
      get disabled() {
        return 'disabled' in loadMoreButton ?
          Boolean(loadMoreButton.disabled) :
          false
      },
      get enabled() {
        return !extendedApi.loadMoreButton.disabled
      },
      disable() {
        if (!extendedApi.loadMoreButton.disabled) {
          loadMoreButton.disable?.()
        }
      },
      enable() {
        if (!extendedApi.loadMoreButton.enabled) {
          loadMoreButton.enable?.()
        }
      },
      onClick(callback: (event: unknown) => void) {
        loadMoreButton.onClick?.(callback)
      },
    },
  }

  return extendComponentAdapter(repeaterAdapter(component), extendedApi)
}